import React from "react";
import { isMobile } from "react-device-detect";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { Download, QrCode, Smartphone, ShieldCheck } from "lucide-react";

const DownloadApp = () => {
  const { t } = useTranslation();

  const apkLink = "https://assistbyscan.com/static/apk/app-debug.apk";

  return (
    <section className="download-page">
      <div className="download-shell">
        <div className="download-copy">
          <p className="download-eyebrow">{t("download_app")}</p>
          <h1>{t("download_title")}</h1>
          <p className="download-lead">
            {isMobile ? t("download_mobile_text") : t("download_desktop_text")}
          </p>

          <div className="download-benefits">
            <span><Smartphone size={16} /> {t("download_feature_android")}</span>
            <span><QrCode size={16} /> {t("download_feature_scan")}</span>
            <span><ShieldCheck size={16} /> {t("download_feature_secure")}</span>
          </div>

          {isMobile && (
            <a className="download-primary" href={apkLink}>
              <Download size={18} />
              {t("download_apk")}
            </a>
          )}
        </div>

        <div className="download-device-card">
          <div className="download-scene">
            <div className="download-orbit download-orbit-one" />
            <div className="download-orbit download-orbit-two" />
            <div className="download-data-chip download-data-chip-one">APK</div>
            <div className="download-data-chip download-data-chip-two">QR</div>

            <div className="download-phone">
              <div className="download-phone-top" />
              <div className="download-phone-screen">
                <div className="download-screen-glow" />
                <div className="download-scan-line" />
                {isMobile ? (
                  <div className="download-mobile-visual">
                    <Smartphone size={52} />
                    <span>APK</span>
                  </div>
                ) : (
                  <div className="download-qr-wrap">
                    <QRCodeCanvas value={apkLink} size={190} />
                  </div>
                )}
                <p>{t("assist_by_scan")}</p>
              </div>
            </div>

            <div className="download-holo-card download-holo-card-left">
              <QrCode size={20} />
              <span>{t("download_holo_scan_fast")}</span>
            </div>

            <div className="download-holo-card download-holo-card-right">
              <ShieldCheck size={20} />
              <span>{t("download_holo_apk_secure")}</span>
            </div>

            <div className="download-floating-note">
              <span>{isMobile ? t("download_tap") : t("download_scan")}</span>
              <strong>{isMobile ? "APK" : "QR"}</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadApp;
